<template>
  <Drawer
    v-model:visible="gorunur"
    position="right"
    :style="{ width: '42rem', maxWidth: '100vw' }"
  >
    <template #header>
      <div>
        <div class="font-bold text-base"><i class="pi pi-question-circle mr-2"></i>{{ govdeBilgisi.Baslik || "Yardım" }}</div>
        <div v-if="govdeBilgisi.WebSayfaAd" class="text-xs text-gray-500 dark:text-gray-400 mt-1">
          {{ govdeBilgisi.WebSayfaAd }} - {{ govdeBilgisi.Tarih }}
        </div>
      </div>
    </template>

    <div class="p-4">
      <YardimGovde :anahtar="anahtar" :aktif="gorunur" @yuklendi="govdeBilgisi = $event" />
    </div>
  </Drawer>
</template>

<script>
import YardimGovde from "./YardimGovde.vue";

// Sayfanın yanında açılan yardım paneli (SB/YR planı) — GenelYardimSayfasi.vue ile aynı
// YardimGovde.vue'yu kullanır, ama route değiştirmez.
// `anahtar` SayfaBasligiAlani.vue'dan yardimAnahtari() sonucu olarak gelir.
export default {
  name: "YardimPaneli",
  components: { YardimGovde },
  props: {
    modelValue: { type: Boolean, default: false },
    anahtar: { type: String, default: null },
  },
  emits: ["update:modelValue"],
  data() {
    return {
      govdeBilgisi: {},
    };
  },
  computed: {
    gorunur: {
      get() {
        return this.modelValue;
      },
      set(v) {
        this.$emit("update:modelValue", v);
      },
    },
  },
};
</script>
